import { action } from 'satcheljs';

import type { OwaNovaActionUnion } from '../types';

export const onAppBarTrigger = action('onAppBarAppTrigger', event => ({
    event,
    owaType: 'appBar',
})) as OwaNovaActionUnion<'appBar'>;
